export function speak(text) {
  if (!("speechSynthesis" in window) || !text) return;
  window.speechSynthesis.cancel();
  const utterance = new SpeechSynthesisUtterance(text);
  utterance.rate = parseFloat(localStorage.getItem("rb_voice_rate") || "0.9");
  utterance.pitch = parseFloat(localStorage.getItem("rb_voice_pitch") || "1.0");
  const voiceName = localStorage.getItem("rb_voice_name");
  if (voiceName) {
    const voice = window.speechSynthesis.getVoices().find((v) => v.name === voiceName);
    if (voice) utterance.voice = voice;
  }
  window.speechSynthesis.speak(utterance);
}

export function listVoices() {
  if (!("speechSynthesis" in window)) return [];
  return window.speechSynthesis.getVoices();
}

export function chime() {
  playJingle("chime");
}

const JINGLES = {
  chime: [[660, 0, 0.9, "sine"], [880, 0.35, 1.1, "sine"]],
  lullaby: [[523, 0, 1.2, "sine"], [440, 0.6, 1.2, "sine"], [392, 1.2, 1.8, "sine"]],
  fun: [[523, 0, 0.22, "square"], [659, 0.18, 0.22, "square"], [784, 0.36, 0.22, "square"], [1047, 0.54, 0.4, "square"], [784, 0.9, 0.22, "square"], [1047, 1.08, 0.5, "square"]],
  bell: [[1319, 0, 0.5, "triangle"], [1319, 0.65, 0.5, "triangle"], [1319, 1.3, 0.9, "triangle"]],
};

export function playJingle(type = "chime") {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    const ctx = new Ctx();
    const notes = JINGLES[type] || JINGLES.chime;
    const vol = type === "lullaby" ? 0.08 : type === "fun" ? 0.06 : 0.12;
    let end = 0;
    for (const [freq, start, dur, wave] of notes) {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = wave;
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(vol, ctx.currentTime + start);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + start + dur);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(ctx.currentTime + start);
      osc.stop(ctx.currentTime + start + dur);
      end = Math.max(end, start + dur);
    }
    setTimeout(() => ctx.close(), (end + 0.5) * 1000);
  } catch { /* audio unavailable */ }
}
